var _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _g3, _g4, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _g5, _path25, _path26, _path27, _path28, _path29, _path30, _g6, _path31, _path32, _path33, _path34, _path35, _path36, _g7, _path37, _path38, _path39, _path40, _path41, _path42, _g8, _g9, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _g10, _path55, _path56, _path57, _path58, _path59, _path60, _g11, _path61, _path62, _path63, _path64, _path65, _path66, _g12, _g13, _path67, _path68, _path69, _path70, _path71, _path72;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDesktopMd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 938,
    height: 427,
    viewBox: "0 0 938 427",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M279.649 200.309L214.135 238.084L59.4907 148.367L127.371 110.592L279.649 200.309Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.479 202.858L147.097 214.744L195.758 186.511L174.4 174.624L126.479 202.858Z",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.479 265.632L147.097 277.518L195.758 249.29L174.4 237.403L126.479 265.632Z",
    stroke: "#231F20",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.599 265.632L147.211 277.518L195.873 249.29L174.515 237.403L126.599 265.632Z",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.097 214.743V277.516",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.21 174.624V237.402L195.736 249.267V186.489",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.479 202.65V265.423",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.0049 174.698L106.623 186.585L155.278 158.356L133.921 146.47L86.0049 174.698Z",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0051 237.476L106.623 249.362L155.279 221.129L133.921 209.242L86.0051 237.476Z",
    stroke: "#231F20",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M86.1248 237.476L106.737 249.362L155.398 221.129L134.041 209.242L86.1248 237.476Z",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M106.623 186.585V249.363",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M133.736 146.47V209.242L155.262 221.107V158.334",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0051 174.491V237.269",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4792 147.968L63.0915 159.855L111.753 131.621L90.3951 119.734L42.4792 147.968Z",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4792 210.741L63.0915 222.627L111.753 194.399L90.3951 182.513L42.4792 210.741Z",
    stroke: "#231F20",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5935 210.741L63.2112 222.627L111.872 194.399L90.5093 182.513L42.5935 210.741Z",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0918 159.855V222.628",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2102 119.734V182.512L111.731 194.377V131.605",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4792 147.762V210.534",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 119.808L22.6177 131.695L71.2788 103.467L49.9212 91.5801L2 119.808Z",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 182.588L22.6177 194.474L71.2788 166.246L49.9212 154.359L2 182.588Z",
    stroke: "#231F20",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.11987 182.588L22.7376 194.474L71.3933 166.246L50.0357 154.359L2.11987 182.588Z",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6177 131.696V194.474",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7366 91.5801V154.358L71.2573 166.223V103.445",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 119.602V182.38",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M268.714 120.281L289.326 132.168L337.987 103.939L316.629 92.0527L268.714 120.281Z",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.713 183.059L289.325 194.945L337.987 166.712L316.629 154.825L268.713 183.059Z",
    stroke: "#231F20",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.827 183.059L289.445 194.945L338.106 166.712L316.749 154.825L268.827 183.059Z",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.326 132.168V194.946",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.444 92.0527V154.825L337.965 166.69V103.917",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.713 120.074V182.852",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M228.713 96.9012L249.331 108.788L297.992 80.5593L276.635 68.6729L228.713 96.9012Z",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M228.713 159.68L249.331 171.567L297.992 143.333L276.635 131.446L228.713 159.68Z",
    stroke: "#231F20",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M228.833 159.68L249.446 171.567L298.107 143.333L276.749 131.446L228.833 159.68Z",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M249.331 108.788V171.566",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M276.445 68.6729V131.445L297.971 143.31V80.5376",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M228.713 96.6943V159.472",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M185.188 70.1683L205.8 82.0548L254.461 53.821L233.104 41.9346L185.188 70.1683Z",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M185.188 132.941L205.8 144.828L254.461 116.599L233.104 104.713L185.188 132.941Z",
    stroke: "#231F20",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M185.302 132.941L205.92 144.828L254.581 116.599L233.223 104.713L185.302 132.941Z",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M205.801 82.0557V144.828",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M232.919 41.9346V104.713L254.44 116.577V53.8047",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M185.188 69.9619V132.734",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.187 47.2606L165.805 59.147L214.466 30.9187L193.109 19.0322L145.187 47.2606Z",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.187 110.039L165.805 121.925L214.466 93.697L193.109 81.8105L145.187 110.039Z",
    stroke: "#231F20",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.307 110.039L165.925 121.925L214.58 93.697L193.223 81.8105L145.307 110.039Z",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.805 59.1475V121.925",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.924 19.0322V81.8102L214.444 93.6749V30.8969",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.187 47.0605V109.833",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M464.981 197.516L444.363 209.402L395.702 181.169L417.059 169.282L464.981 197.516Z",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M464.981 260.29L444.363 272.176L395.702 243.948L417.059 232.062L464.981 260.29Z",
    stroke: "#231F20",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M464.861 260.29L444.248 272.176L395.587 243.948L416.945 232.062L464.861 260.29Z",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M444.363 209.403V272.176",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M417.25 169.282V232.06L395.724 243.925V181.152",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M464.98 197.31V260.082",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M638.006 348.439L572.491 386.214L417.847 296.497L485.728 258.722L638.006 348.439Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M423.94 220.713L403.328 232.6L354.667 204.366L376.025 192.479L423.94 220.713Z",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.94 283.487L403.328 295.374L354.667 267.145L376.025 255.259L423.94 283.487Z",
    stroke: "#231F20",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.826 283.487L403.209 295.374L354.548 267.145L375.905 255.259L423.826 283.487Z",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.328 232.6V295.372",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.209 192.479V255.257L354.689 267.122V204.344",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.941 220.507V283.279",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  }))), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M596.422 228.906L575.804 240.792L527.143 212.558L548.506 200.672L596.422 228.906Z",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M596.422 291.68L575.804 303.566L527.143 275.338L548.506 263.451L596.422 291.68Z",
    stroke: "#231F20",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M596.302 291.68L575.69 303.566L527.029 275.338L548.387 263.451L596.302 291.68Z",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M575.804 240.793V303.566",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M548.691 200.672V263.45L527.165 275.315V212.537",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M596.422 228.699V291.472",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M660.305 264.32L639.687 276.207L591.026 247.978L612.389 236.092L660.305 264.32Z",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.305 327.098L639.687 338.985L591.026 310.751L612.389 298.864L660.305 327.098Z",
    stroke: "#231F20",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.185 327.098L639.573 338.985L590.912 310.751L612.269 298.864L660.185 327.098Z",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.687 276.207V338.985",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.574 236.092V298.864L591.048 310.729V247.957",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.304 264.113V326.891",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  }))), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M481.741 186.446L502.359 198.333L551.015 170.104L529.657 158.218L481.741 186.446Z",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M481.741 249.224L502.359 261.11L551.015 232.877L529.657 220.99L481.741 249.224Z",
    stroke: "#231F20",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M481.856 249.224L502.473 261.11L551.135 232.877L529.777 220.99L481.856 249.224Z",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M502.359 198.333V261.111",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M529.472 158.218V220.99L550.998 232.855V170.082",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M481.741 186.239V249.017",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M436.371 158.163L456.989 170.05L505.65 141.816L484.287 129.93L436.371 158.163Z",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.371 220.937L456.989 232.824L505.65 204.595L484.287 192.709L436.371 220.937Z",
    stroke: "#231F20",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.49 220.937L457.103 232.824L505.764 204.595L484.406 192.709L436.49 220.937Z",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.102 129.93V192.708L505.628 204.572V141.8",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.371 220.73V157.957L456.989 170.05V232.823",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M484.836 350.98L505.454 362.867L554.115 334.638L532.757 322.752L484.836 350.98Z",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.836 413.758L505.454 425.645L554.115 397.411L532.757 385.524L484.836 413.758Z",
    stroke: "#231F20",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.956 413.758L505.568 425.645L554.229 397.411L532.871 385.524L484.956 413.758Z",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.454 362.867V425.645",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.567 322.752V385.525L554.093 397.389V334.617",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.836 350.773V413.551",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  }))), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M444.362 322.828L464.98 334.714L513.641 306.48L492.278 294.594L444.362 322.828Z",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M444.362 385.601L464.98 397.488L513.641 369.26L492.278 357.373L444.362 385.601Z",
    stroke: "#231F20",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M444.481 385.601L465.094 397.488L513.755 369.26L492.397 357.373L444.481 385.601Z",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M464.979 334.715V397.487",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M492.092 294.594V357.372L513.619 369.236V306.464",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M444.362 322.621V385.394",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M935.999 165.697L915.387 177.584L866.726 149.355L888.083 137.469L935.999 165.697Z",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M936 228.476L915.387 240.362L866.726 212.129L888.084 200.242L936 228.476Z",
    stroke: "#231F20",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M935.885 228.476L915.268 240.362L866.606 212.129L887.969 200.242L935.885 228.476Z",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M915.387 177.584V240.362",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M888.269 137.469V200.241L866.748 212.106V149.333",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M936 165.489V228.267",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M881.317 191.222L815.802 228.998L661.158 139.28L729.039 101.505L881.317 191.222Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M901.205 190.139L880.588 202.026L831.927 173.798L853.284 161.911L901.205 190.139Z",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M901.086 252.917L880.474 264.804L831.812 236.57L853.17 224.684L901.086 252.917Z",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M880.587 202.026V264.804",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M853.474 161.911V224.684L831.948 236.548V173.776",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M901.205 189.933V252.711",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  }))), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M839.733 71.6879L819.116 83.5744L770.455 55.3406L791.818 43.4541L839.733 71.6879Z",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M839.733 134.46L819.116 146.346L770.455 118.118L791.818 106.231L839.733 134.46Z",
    stroke: "#231F20",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M839.613 134.46L819.001 146.346L770.34 118.118L791.698 106.231L839.613 134.46Z",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M819.115 83.5742V146.347",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M792.002 43.4541V106.232L770.476 118.097V55.3242",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M839.733 71.4814V134.254",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M903.616 107.103L882.998 118.99L834.337 90.7615L855.694 78.875L903.616 107.103Z",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M903.616 169.881L882.998 181.768L834.337 153.534L855.694 141.647L903.616 169.881Z",
    stroke: "#231F20",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M903.496 169.881L882.884 181.768L834.222 153.534L855.58 141.647L903.496 169.881Z",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M882.998 118.99V181.768",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M855.885 78.875V141.648L834.359 153.518V90.7397",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M903.615 106.896V169.673",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  }))), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M725.052 29.2283L745.664 41.1148L794.325 12.8865L772.968 1L725.052 29.2283Z",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M725.052 92.0063L745.664 103.893L794.325 75.6589L772.968 63.7725L725.052 92.0063Z",
    stroke: "#231F20",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M725.166 92.0063L745.784 103.893L794.445 75.6589L773.087 63.7725L725.166 92.0063Z",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M745.664 41.1152V103.893",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M772.783 1V63.7725L794.303 75.6427V12.8647",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M725.052 29.0215V91.7995",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M646.617 140.695L667.229 152.581L715.89 124.347L694.533 112.461L646.617 140.695Z",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.617 203.469L667.229 215.355L715.891 187.127L694.533 175.24L646.617 203.469Z",
    stroke: "#231F20",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.731 203.469L667.349 215.355L716.01 187.127L694.653 175.24L646.731 203.469Z",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694.348 112.461V175.239L715.874 187.104V124.331",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.617 203.261V140.488L667.229 152.581V215.354",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M728.147 193.763L748.765 205.649L797.426 177.421L776.063 165.534L728.147 193.763Z",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M728.147 256.54L748.765 268.427L797.426 240.193L776.063 228.307L728.147 256.54Z",
    stroke: "#231F20",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M728.267 256.54L748.879 268.427L797.54 240.193L776.182 228.307L728.267 256.54Z",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M748.765 205.649V268.427",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M775.878 165.534V228.307L797.404 240.177V177.399",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M728.147 193.556V256.334",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  }))), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M687.673 165.611L708.291 177.498L756.947 149.269L735.589 137.383L687.673 165.611Z",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M687.673 228.384L708.291 240.27L756.947 212.042L735.589 200.155L687.673 228.384Z",
    stroke: "#231F20",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M687.793 228.384L708.405 240.27L757.066 212.042L735.709 200.155L687.793 228.384Z",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M708.291 177.498V240.271",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M735.404 137.383V200.155L756.931 212.02V149.248",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M687.673 165.404V228.177",
    stroke: "white",
    strokeWidth: 1.24577,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopMd);
export default __webpack_public_path__ + "static/media/desktop-md.f14ab521294f03517ab2e99675d7a782.svg";
export { ForwardRef as ReactComponent };